import React from 'react'
import Explanation from './Explanation';
import ImageSection from './ImageSection';
import Disadvantage from './Disadvantage';
import TextSlider from './TextSlider';
import FaqSection from './FaqSection';
import ProjectSelectionSection from './ProjectSelectionSection';
import SoftwareFeatureSection from './SoftwareFeatureSection';
import StandardSoftwareChaos from './StandardSoftwareChaos';
import { TSolutionBlock } from '../../../types/index';

const componentMap: Record<string, React.FC<any>> = {
  'software-solutions.explanation': Explanation,
  'software-solutions.image': ImageSection,
  'software-solutions.disadvantage': Disadvantage,
  'software-solutions.text-slider': TextSlider,
  'software-solutions.faq': FaqSection,
  'software-solutions.project-selection': ProjectSelectionSection,
  'software-solutions.software-functions': SoftwareFeatureSection,
  'software-solutions.standard-chaos': StandardSoftwareChaos,
};

export default function DynamicSection({ dynamic }: { dynamic: TSolutionBlock[] }) {
  return (
    <div>
        {dynamic.map((block, idx) => {
            const Component = componentMap[block.__component];
            if (!Component) {
                console.warn(`No component found for ${block.__component}`);
                return null;
            }
            const isImageSectionDarkBg = block.__component === "software-solutions.image" && (block.view === "w-section_animation_darkBg" || block.view === "w-section_no-animation_darkBg" || block.view === "w-full_no-animation");
            const sectionKey = `${block.__component}-${block.id}-${idx}`;
            return (
              <section key={sectionKey} className={block.darkBg || isImageSectionDarkBg ? "" : "bg-base-200"}>
                <Component {...block} />
              </section>
            );
        })}      
    </div>
  )
}
